/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

/* --------------- GOOGLE ANALYTICS --------------- */
const GA_TAG_DEV = "G-D432L5ZVBH";
const GA_TAG_PROD = "G-0HGSK48GQ5";
export const GA_TAG = process.env.ENVIRONMENT === "prod" ? GA_TAG_PROD : GA_TAG_DEV;
export const ALGOLIA_INDEX_NAME = process.env.ENVIRONMENT;
